import request from '../utils/request';

//售后列表
export async function getSignList(state, skip, take) {
  return await request(`platbiz/applylist?state=${state}&skip=${skip}&take=${take}`, 'get');
}
export async function dealSign(data) {
  return await request('platbiz/applydeal', 'put', data);
}